<template>
  <div class="spinner">
    <img
      src="../assets/loading.svg"
      alt="Loading"
    >
  </div>
</template>

<script>
import HMApi from '@/api/herningMobilitetApi';

export default {
  methods: {
    handleLoginEvent(data) {
      // Hent bruger i applikationsdatabasen
      HMApi.getMe(data.idToken)
        .then(user => {
          // Check for email verified
          if (!data.profile.email_verified) {
            if (user === null) {
              // Vi kenden ikke brugeren og konto er ikke bekræftet.
              // Giv brugeren besked om at han hun skal bekræfte sin email og loade igen
              this.$router.push(data.state.target || '/notification/1');
            } else {
              // Vi kender brugeren, men kontoen er ikke bekræftet.
              // Giv brugeren besked om at han hun skal bekræfte sin email og loade igen
              this.$router.push(data.state.target || '/notification/2');
            }
            return;
          }
          localStorage.setItem('token', data.idToken);
          // email is verified. Move on...
          if (user === null) {
            // Bruger er logget ind, men er ukendt i applikationsdatabase. Opret brugeren
            HMApi.createUser(data.profile.email, data.profile.name)
              .then(userId => {
                // Bruger er nu oprettet i applikationsdatabasen. Viderestil til forside.
                this.$router.push(data.state.target || '/');
              })
              .catch(() => {
                console.log('ERROR: create user failed');
                this.$router.push(data.state.target || '/notification/3');
              });
          } else {
            // Kendt bruger, der er logget ind. Viderestil til forside.
            this.$router.push(data.state.target || '/');
          }
        })
        // GetMe fejlede. Det burde ikke ske.
        .catch(() => {
          console.log('ERROR: get user failed');
          this.$router.push(data.state.target || '/notification/4');
        });
    },
  },
  created() {
    this.$auth
      .handleAuthentication()
      .then(resp => {
        // console.log(resp);
      })
      .catch(err => {
        if (err.error === 'access_denied') {
          // const desc = err.errorDescription; // 'User did not authorize the request'
          this.$router.push('/');
        } else if (err.error === 'unauthorized') {
          if (err.errorDescription === 'Access denied. Illegal domain.') {
            this.$router.push('/notification/5');
          } else if (err.errorDescription === 'Access denied. Account created but email is not verified.') {
            this.$router.push('/notification/1');
          } else if (err.errorDescription === 'Access denied. Account exists but email is not verified.') {
            this.$router.push('/notification/6');
          } else {
            this.$router.push('/');
          }
        } else {
          this.$router.push('/');
        }
      });
  },
};
</script>

<style scoped>
.spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
